import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=0f55a252"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"
import style0 from "./Folders.vue?vue&type=style&index=0&id=0f55a252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports